export enum ChargeState {
    None,
    ArriveToCharger,
    Charging,
    ChargeFinish
}
